import { render, staticRenderFns } from "./TvProvisioningDashboard.vue?vue&type=template&id=f115a5ae&scoped=true&"
import script from "./TvProvisioningDashboard.vue?vue&type=script&lang=js&"
export * from "./TvProvisioningDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f115a5ae",
  null
  
)

export default component.exports